import { render } from "./CustomerStatistics.vue?vue&type=template&id=26fce7f9&scoped=true"
import script from "./CustomerStatistics.vue?vue&type=script&lang=js"
export * from "./CustomerStatistics.vue?vue&type=script&lang=js"

import "./CustomerStatistics.vue?vue&type=style&index=0&id=26fce7f9&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26fce7f9"]])

export default __exports__